import { useTranslation } from "react-i18next";

const Testimonials = () => {
  const { t } = useTranslation();
  const testimonials = [
    {
      quote: "Pasé de no entender nada a generar mis primeros 800 USD en mi segundo mes. La comunidad es lo mejor del programa.",
      name: "Andrea López",
      role: "Bogotá, Colombia",
      avatar: "https://images.pexels.com/photos/12902865/pexels-photo-12902865.jpeg",
    },
    {
      quote: "Koni (el bot) me convenció de tomar el curso de IA. La verdad ya tengo 3 clientes pagándome con los flujos que aprendí.",
      name: "Diego Hernández",
      role: "CDMX, México",
      avatar: "https://images.pexels.com/photos/20752572/pexels-photo-20752572.jpeg",
    },
    {
      quote: "Al fin algo en español pensado para nosotros. Las plantillas de e-commerce me ahorraron meses de trabajo.",
      name: "Camila Suárez",
      role: "Buenos Aires, Argentina",
      avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200",
    },
  ];

  return (
    <section id="testimonios" data-testid="testimonials-section" className="py-24 md:py-32 border-b border-zinc-200">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-16">
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#4F46E5] mb-4">{t("testimonials.tag")}</p>
          <h2 className="font-display font-black text-4xl md:text-6xl tracking-tighter leading-[0.95]">
            {t("testimonials.title1")} <span className="text-[#4F46E5]">{t("testimonials.title2")}</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((tt, i) => (
            <figure key={tt.name} data-testid={`testimonial-${i}`} className="bg-white border border-zinc-200 p-8 md:p-10 flex flex-col h-full">
              <div className="text-5xl font-display font-black text-[#4F46E5] leading-none mb-6">&ldquo;</div>
              <blockquote className="text-lg text-zinc-800 leading-relaxed flex-1">{tt.quote}</blockquote>
              <figcaption className="mt-8 pt-6 border-t border-zinc-200 flex items-center gap-3">
                <img src={tt.avatar} alt={tt.name} className="w-10 h-10 rounded-full object-cover" />
                <div>
                  <div className="font-semibold text-sm">{tt.name}</div>
                  <div className="text-xs text-zinc-500">{tt.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
